import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

// Convenience gate only — credentials live client-side, not real security.
// This exists so each school principal lands pre-scoped to their own branch.
const LOGIN_ACCOUNTS = {
  admin:        { password: 'Admin@2026',    role: 'administrator', branch: null,                        displayName: 'Administrator' },
  admin:        { password: 'admin',    role: 'administrator', branch: null,                        displayName: 'Administrator' },
  madhapur:     { password: 'Madhapur@2026', role: 'principal',     branch: 'Global Edge, Madhapur',     displayName: 'Madhapur Principal' },
  kokapet:      { password: 'Kokapet@2026',  role: 'principal',     branch: 'Global Edge, Kokapet',      displayName: 'Kokapet Principal' },
  kphb:         { password: 'Kphb@2026',     role: 'principal',     branch: 'Global Edge, KPHB',         displayName: 'KPHB Principal' },
  vasanthnagar: { password: 'Vasanth@2026',  role: 'principal',     branch: 'Global Edge, Vasanth nagar', displayName: 'Vasanth Nagar Principal' },
};

export const AuthProvider = ({ children }) => {
  // Try to restore session from sessionStorage
  const [user, setUser] = useState(() => {
    const saved = sessionStorage.getItem('gesLoginUser');
    if (saved && LOGIN_ACCOUNTS[saved]) {
      const account = LOGIN_ACCOUNTS[saved];
      return { username: saved, role: account.role, branch: account.branch, displayName: account.displayName };
    }
    return null;
  });

  const branchLock = user ? user.branch : null;

  const login = (usernameRaw, password) => {
    const username = (usernameRaw || '').trim().toLowerCase();
    const account = LOGIN_ACCOUNTS[username];
    if (!account || account.password !== password) return false;
    const loggedIn = { username, role: account.role, branch: account.branch, displayName: account.displayName };
    setUser(loggedIn);
    sessionStorage.setItem('gesLoginUser', username);
    return true;
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('gesLoginUser');
  };

  return (
    <AuthContext.Provider value={{ user, branchLock, login, logout, loading: false }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
